import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import './assets/styles/main.scss'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import VueResource from 'vue-resource'
Vue.use(VueResource)

const API_BASE_URL = process.env.NODE_ENV == 'production' ? 'https://iq.sixaxisllc.com' : 'http://127.0.0.1:9001' // 'https://api-sixaxis.ngrok.io'
Vue.http.options.root = API_BASE_URL

import moment from 'moment-timezone'
Vue.prototype.moment = moment

Vue.filter('moment', function (value, format = '') {
  return moment(value).format(format)
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
